import React from 'react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  return <section className="bg-white px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-224">
      <div className="mx-auto max-w-3xl" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8 font-sans text-xl leading-loose text-[#2D2D2D]/90" data-id="element-226">
          <h2 className="mb-8 text-center font-serif text-4xl font-bold text-[#2D2D2D]" data-id="element-227">
            Here's what's true:
          </h2>

          <p data-id="element-228">
            Every week you spend running the wrong system is another week your
            body fights itself instead of healing.
          </p>
          <p data-id="element-229">
            Every week of cortisol-spiking, diastasis-worsening,
            identity-eroding trial and error costs you more than time.
          </p>
          <p data-id="element-230">
            The postpartum window is one of the most powerful opportunities for
            transformation your body will ever experience. The hormonal
            fluidity, the tissue plasticity, the neurological rewiring — all of
            it creates a window for change that doesn't stay open forever.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.98
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="my-8 rounded-2xl bg-[#FBF7F0] p-8 text-center" data-id="element-231">
            <p className="font-serif text-2xl font-bold leading-relaxed text-[#D4603A]" data-id="element-232">
              The question isn't whether to do this. The question is whether you
              do it now or six months from now when the window is smaller and
              the identity gap is deeper.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}